import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // Log error for debugging
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/dashboard';
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F5F5F7] dark:bg-[#1C1C1E] flex items-center justify-center p-4">
          <div className="bg-white dark:bg-white/5 rounded-3xl p-8 max-w-md w-full text-center shadow-lg border border-black/5 dark:border-white/10">
            <div className="w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mx-auto mb-6">
              <AlertTriangle className="text-amber-600" size={32} />
            </div>
            
            <h1 className="text-xl font-bold text-[#1D1D1F] dark:text-white mb-2">
              Qualcosa è andato storto
            </h1>
            <p className="text-[#86868B] mb-6">
              Si è verificato un errore imprevisto. Prova a ricaricare la pagina o torna alla home.
            </p>
            
            <div className="flex flex-col gap-3">
              <button
                onClick={this.handleReload}
                className="w-full h-12 bg-[#2E7D32] hover:bg-[#1B5E20] text-white rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
              >
                <RefreshCw size={18} />
                Ricarica pagina
              </button>
              
              <button
                onClick={this.handleGoHome}
                className="w-full h-12 bg-[#F5F5F7] dark:bg-white/10 hover:bg-[#E5E5EA] dark:hover:bg-white/20 text-[#1D1D1F] dark:text-white rounded-xl font-medium flex items-center justify-center gap-2 transition-colors"
              >
                <Home size={18} />
                Vai alla Dashboard
              </button>
              
              <button
                onClick={this.handleGoBack}
                className="text-[#86868B] text-sm hover:text-[#1D1D1F] dark:hover:text-white transition-colors"
              >
                Torna indietro
              </button>
            </div>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 rounded-xl text-left">
                <p className="text-xs font-mono text-red-600 dark:text-red-400 break-all">
                  {this.state.error.toString()}
                </p>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
